export const SEARCH_YOUTUBE = 'Søg youtube...';